<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      color="primary"
      elevation="1"
      height="80"
    >
      <v-toolbar-title style="width: auto;" class="white--text font-weight-bold;">
        Pronewtec
        <p style="font-size: 15px; margin: 0;">3 Impasse Champs au Roi,</p>
        <p style="font-size: 15px; margin: 0;">90100 Saint Dizier L'Evêque</p>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-tabs
          class="hidden-md-and-down primary"
          background-color="primary"
        >
          <v-tab
            v-for="(el, i) in items"
            v-model="open"
            :key="i"
            :exact="el.name === 'Home'"
            :ripple="false"
            active-class="font-weight-bold white--text primary"
            class="font-weight-bold primary"
            min-width="96"
            text
            @click="close(el, $vuetify, options)"
          >
            {{ el.name }}
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon
        class="hidden-lg-and-up"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <home-drawer
      v-model="drawer"
      :items="items"
      :options="options"
    />
  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    components: {
      HomeDrawer: () => import('./Drawer'),
    },
    computed : {
      options(){
        return {
          duration: 300,
          offset: 0,
          easing: 'easeInOutCubic',
        }
      },
    },
    data: () => { return {
      drawer: null,
      open : false,
      items: [
        { name: 'Accueil', link: '#hero', open : true },
        { name: 'Démarrage', link: '#theme-features', open : false },
        { name: 'En Marche', link: '#en-marche', open : false },
        { name: 'Hivernage', link: '#features', open : false },
        { name: 'Nos Produits', link: '#nos-produits', open : false },
        { name: 'Calcul Interactif', link: '#calcul', open : false },
        { name: 'Nos Revendeurs', link: '#nos-revendeurs', open : false },
        { name: 'FAQ', link: '#faq', open : false },
        { name: 'Nos clients', link: '#affiliates', open : false },
        { name: 'Contactez-Nous', link: '#info-alt', open : false },
      ],
    } },

    methods : {
      close(el, v = null, options = null) {
        this.open = false;
         v.goTo(el.link, options)
      }
    },
  }
</script>

<style lang="sass">

</style>
